import React, { useMemo } from "react";
import { toast, ToastContainer } from "react-toastify";

const CampaignAudience = ({
 contacts = [],
  audience = [],
  createAudienceGroup = async () => {},
  selectedAudienceGroup = null,
  handleAudienceGroupChange = () => {},
  selectedItems = [],
  handleSelect = () => {},
  handleDeselect = () => {},
  next = () => {},
  back = () => {},
}) => {
  // Safe audience list
  const safeAudience = Array.isArray(audience) ? audience : [];

  //  IMPORTANT: define baseContacts FIRST
  const baseContacts = selectedAudienceGroup
    ? selectedAudienceGroup?.members || []
    : contacts || [];

  const safeContacts = Array.isArray(baseContacts) ? baseContacts : [];

  // Search states (local)
  const [searchName, setSearchName] = React.useState("");
  const [searchTag, setSearchTag] = React.useState("");
const [groupName, setGroupName] = React.useState("");
const [groupCreating, setGroupCreating] = React.useState(false);

  // Filtered contacts
  const safeFilteredContacts = useMemo(() => {
    return safeContacts.filter((contact) => {
      const nameMatch = searchName
        ? contact?.contact_name
            ?.toLowerCase()
            .includes(searchName.toLowerCase())
        : true;

      const tagMatch = searchTag
        ? contact?.tags?.some((t) =>
            t?.toLowerCase().includes(searchTag.toLowerCase()),
          )
        : true;

      return nameMatch && tagMatch;
    });
  }, [safeContacts, searchName, searchTag]);

  // Safe selected list
  const safeSelectedItems = Array.isArray(selectedItems) ? selectedItems : [];

  const handleSelectAllContacts = () => {
    safeFilteredContacts.forEach((contact) => {
      if (!safeSelectedItems.some((i) => i.id === contact.id)) {
        handleSelect(contact);
      }
    });
  };

  const handleDeselectAllContacts = () => {
    safeFilteredContacts.forEach((contact) => {
      if (safeSelectedItems.some((i) => i.id === contact.id)) {
        handleDeselect(contact);
      }
    });
  };

const removeEmojis = (value = "") => {
  return String(value)
    .replace(
      /[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}]/gu,
      ""
    )
    .trim();
};

const getSafeContactName = (member) => {
  const cleanName = removeEmojis(member.contact_name);
  return cleanName || member.contact_number || "Unknown";
};

const handleCreateGroup = async () => {
  if (!groupName.trim()) {
    toast.error("Please enter group name");
    return;
  }

  if (!safeSelectedItems.length) {
    toast.error("Please select at least one contact");
    return;
  }

  try {
    setGroupCreating(true);

    const payload = {
      audienceGroupName: groupName.trim(),
      members: safeSelectedItems.map((member) => ({
        id: member.id,
        contact_name: getSafeContactName(member),
        contact_number: member.contact_number,
      })),
    };

    const res = await createAudienceGroup(payload);

    if (res?.responseCode === "00") {
      toast.success(
        res?.data?.message ||
          res?.responseMessage ||
          "Audience group created successfully"
      );

      setGroupName("");
    } else {
      const errorMsg = res?.responseMessage || "";

      if (errorMsg.includes("Incorrect string value")) {
        toast.error(
          "Some contact names contain emojis/special characters. Please remove them and try again."
        );
      } else {
        toast.error(errorMsg || "Failed to create audience group");
      }
    }
  } catch (error) {
    console.error("Create audience group error:", error);
    toast.error("Failed to create audience group");
  } finally {
    setGroupCreating(false);
  }
};

  return (
    <>
<ToastContainer/>
    <div className="w-full px-8 py-6 montserrat-font-1">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 montserrat-font-1">
        {/* LEFT PANEL */}
        <div className="lg:col-span-7 border rounded-xl bg-white montserrat-font-1">
          {/* Header */}
          <div className="flex justify-between items-center border-b p-4 montserrat-font-1">
            <h2 className="font-semibold text-lg">
              {selectedAudienceGroup
                ? `Members of ${selectedAudienceGroup.audience_group_name}`
                : "All Contact List"}
            </h2>

            <select
              value={selectedAudienceGroup?.id || ""}
              onChange={handleAudienceGroupChange}
              className="border rounded-md px-3 py-2 text-sm"
            >
              <option value="">All Contact List</option>
             {safeAudience
  .map((group) => {
    const groupName =
      group?.audience_group_name ||
      group?.audienceGroupName ||
      group?.group_name ||
      group?.name ||
      "";

    return {
      ...group,
      displayName: String(groupName).trim(),
    };
  })
  .filter((group) => group.displayName)
  .map((group) => (
    <option key={group.id} value={group.id}>
      {group.displayName}
    </option>
  ))}
            </select>
          </div>

          {/* Filters */}
          <div className="p-4 space-y-4 montserrat-font-1">
            <div className="flex gap-3 flex-wrap montserrat-font-1">
              <input
                type="text"
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
                placeholder="Search by name"
                className="border rounded-md px-3 py-2 flex-1 min-w-[180px]"
              />

              <input
                type="text"
                value={searchTag}
                onChange={(e) => setSearchTag(e.target.value)}
                placeholder="Search by tag"
                className="border rounded-md px-3 py-2 flex-1 min-w-[180px]"
              />

              <button
                onClick={() => {
                  setSearchName("");
                  setSearchTag("");
                }}
                className="bg-blue-600 text-white px-4 py-2 rounded-md text-sm"
              >
                Clear
              </button>
            </div>

            {/* Select Buttons */}
            <div className="flex gap-3 montserrat-font-1">
              <button
                onClick={handleSelectAllContacts}
                className="border border-blue-600 text-blue-600 px-4 py-2 rounded-md text-sm"
              >
                Select All
              </button>

              <button
                onClick={handleDeselectAllContacts}
                className="border border-blue-600 text-blue-600 px-4 py-2 rounded-md text-sm"
              >
                Deselect All
              </button>
            </div>

            <hr />

            {/* Contact List */}
            <div className="h-[400px] border rounded-md overflow-y-auto montserrat-font-1">
              {safeFilteredContacts.map((contact) => {
                const isSelected = safeSelectedItems.some(
                  (item) => item.id === contact.id,
                );

                return (
                  <div
                    key={contact.id}
                    className="flex items-center gap-3 px-3 py-2 border-b hover:bg-gray-50 montserrat-font-1"
                  >
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() =>
                        isSelected
                          ? handleDeselect(contact)
                          : handleSelect(contact)
                      }
                      className="accent-blue-600"
                    />

                    <div>
                      <div className="text-sm font-medium montserrat-font-1">
                        {contact.contact_name}
                      </div>
                      <div className="text-xs text-gray-500">
                        {contact.contact_number}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="lg:col-span-5 bg-gray-50 border rounded-xl p-4 montserrat-font-1">
          <h2 className="text-lg font-semibold mb-3 montserrat-font-1">
            Selected Audience
          </h2>

          <div className="flex gap-2 mb-3 montserrat-font-1">
          <input
  type="text"
  placeholder="Enter group name.."
  value={groupName}
  onChange={(e) => setGroupName(e.target.value)}
  className="flex-1 border rounded-md px-3 py-2"
/>

<button
  type="button"
  onClick={handleCreateGroup}
  disabled={groupCreating || !groupName.trim() || !safeSelectedItems.length}
  className={`px-4 py-2 rounded-md text-white ${
    groupCreating || !groupName.trim() || !safeSelectedItems.length
      ? "bg-blue-300 cursor-not-allowed"
      : "bg-blue-600 hover:bg-blue-700"
  }`}
>
  {groupCreating ? "Creating..." : "Create Group"}
</button>
          </div>

          <div className="bg-blue-100 text-blue-800 p-3 rounded-md text-sm mb-3 montserrat-font-1">
            <strong>How to Create an Audience Group:</strong>
            <ul className="list-disc ml-4 mt-1">
              <li>Enter a group name.</li>
              <li>Select at least one contact.</li>
              <li>Click "Create Group" to save.</li>
            </ul>
          </div>

          <div className="flex gap-2 mb-3 montserrat-font-1">
            <input
              type="text"
              placeholder="Search..."
              className="flex-1 border rounded-md px-3 py-2"
            />
            <button className="border px-4 py-2 rounded-md">Clear</button>
          </div>

          <p className="font-medium mb-2 montserrat-font-1">
            Selected: {safeSelectedItems.length}
          </p>

          <div className="max-h-[350px] overflow-y-auto space-y-2 montserrat-font-1">
            {safeSelectedItems.map((item) => (
              <div
                key={item.id}
                className="bg-white border px-3 py-1 rounded-md flex justify-between items-center"
              >
                {item.contact_name}
                <button
                  onClick={() => handleDeselect(item)}
                  className="text-red-500"
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Navigation */}
      <div className="flex justify-end gap-5 mt-6 montserrat-font-1">
        <button onClick={back} className="bg-gray-300 px-6 py-2 rounded-md">
          Previous
        </button>

        <button
          onClick={() => {
            if (!safeSelectedItems.length) {
              toast.error("Select at least one contact");
              return;
            }
            next();
          }}
          className="bg-blue-600 text-white px-6 py-2 rounded-md"
        >
          Next
        </button>
      </div>
    </div>
    </>
  );
};

export default CampaignAudience;
